import { render, staticRenderFns } from "./TipsDialog.vue?vue&type=template&id=42f6b99e&scoped=true"
import script from "./TipsDialog.vue?vue&type=script&lang=js"
export * from "./TipsDialog.vue?vue&type=script&lang=js"
import style0 from "./TipsDialog.vue?vue&type=style&index=0&id=42f6b99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f6b99e",
  null
  
)

export default component.exports